import React from 'react';
import Link from '../../../components/LocalizedLink';

const yritused = {
	'yritused.yld.pealkiri': 'Events',
	'yritused.yld.blokk1': () => (
		<>
			<h2 className='title is-2'>Parties in Varbla Holiday village</h2>
			<p>
				Wide range of different accommotaion options, great food, big
				campingsite and beautiful sandbeach, is what we have to offer for your
				summerdays, winterdays, get-togethers, birthdays, conferences or
				weddings.
			</p>
		</>
	),
	'yritused.suvepaevad.pealkiri': 'Company holidays',
	'yritused.suvepaevad.kaart.kirjeldus':
		'Varbla Holiday Village is the perfect place to have your company holiday',
	'yritused.suvepaevad.blokk1': () => (
		<>
			<h2 className='title is-2'>Company holidays in Varbla</h2>
			<p>
				Varbla Holiday Village is the perfect place to have your company
				holiday. We will help you to a great party with many activities.
			</p>
			<p>Why should you have your company holiday in Varbla Holiday Village?</p>
			<ul>
				<li>Beautiful place on the coast of the Baltic sea.</li>
				<li>
					Versatile complex with rooms, apartments and houses for 154 guests.
				</li>
				<li>
					Collaboration with our partners, we offer you alot of activities to
					spend your free time, that includes surfing lessons, horse-riding and
					party games
				</li>
				<li>
					Great food, which is gotten alot of good feedback and is mostly made
					from local ingredients.
				</li>
				<li>Large campingsite with picnic tables and kiosk</li>
				<li>Big parking space</li>
				<li>Motel Bar and Kiosk at the campingsite</li>
				<li>
					2 different saunas, one near the Motel and another next to the
					campingsite
				</li>
				<li>
					Breakfast, Lunch and Dinner. If needed, also a late night snack.
				</li>
			</ul>
		</>
	),
	'yritused.suvepaevad.blokk2': () => (
		<>
			<p>
				More about the accommodation click <Link to='/majutus'>here</Link>, More
				about the food click <Link to='/toitlustus'>here</Link>.
			</p>
		</>
	),
	'yritused.suvepaevad.blokk3': () => <></>,
	'yritused.synnipaevad.pealkiri': 'Birthdays',
	'yritused.synnipaevad.kaart.kirjeldus':
		'Every persons birthday has to be special.',
	'yritused.synnipaevad.blokk1': () => (
		<>
			<h2 className='title is-2'>Birthdays in Varbla Holiday Village</h2>
			<p>Every persons birthday has to be special.</p>
			<p>
				We will do our best, so that they can just sit back and enjoy it with
				great and local food made by our friendly family.
			</p>
			<p>If needed, we will help you find a band and a evening host.</p>
		</>
	),
	'yritused.synnipaevad.blokk2': () => <></>,
	'yritused.seminarid.pealkiri': 'Conferences',
	'yritused.seminarid.kaart.kirjeldus':
		'A Conference in Varbla Holiday Village brings up new ideas for every company.',
	'yritused.seminarid.blokk1': () => (
		<>
			<h2 className='title is-2'>Conferences in Varbla Holiday Village</h2>
			<p>
				A Conference in Varbla Holiday Village brings up new ideas for every
				company.
			</p>
			<p>
				Our conference room can fit 40 guests and our dining room is great for
				bigger groups.
			</p>
			<ul>
				<li>Breakfast, lunch, dinner, coffee breaks or even a sauna snack</li>
				<li>after dinner sauna and/or barrel sauna</li>
				<li>Accommodation in our Motel or apartment-style houses.</li>
			</ul>
			<p>Conference room</p>
			<ul>
				<li>Up to 40 persons</li>
				<li>WiFI</li>
				<li>Video projector and a screen</li>
				<li>Flipchart</li>
				<li>Terrace and sea view</li>
			</ul>
		</>
	),
	'yritused.seminarid.blokk2': () => <></>,
	'yritused.pulmad.pealkiri': 'Weddings',
	'yritused.pulmad.kaart.kirjeldus':
		'Wedding by the sea - every couples dream...',
	'yritused.pulmad.blokk1': () => (
		<>
			<h2 className='title is-2'>Weddings in Varbla Holiday Village</h2>
			<p>
				Wedding by the sea, is almost every couples dream. We are a great place
				for small or big weddings. our party room can fit up-to 100 guests. IN
				the summer, we can accommodate 154 guest and in the winter 98 guests.
			</p>
			<p>Why should you have your wedding in Varbla Holiday Village?</p>
			<ul>
				<li>Romantic and private place by the sea</li>

				<li>A lot of experiences, when it comes to hosting a wedding.</li>
				<li>
					Up to 100 guest and there's still room for champange table, food,
					musicians and dancers.
				</li>
				<li>Great food and friendly staff</li>
				<li>Different accommodation options</li>
			</ul>
		</>
	),
	'yritused.pulmad.blokk2': () => (
		<>
			<p>
				More about the accommodation click <Link to='/majutus'>here</Link>, More
				about the food click <Link to='/toitlustus'>here</Link>.
			</p>
		</>
	),
};

export default yritused;
